import React, { useEffect, useState } from "react";
import { Input, Col, Row } from "reactstrap";
//import QuestionModalInfo,{ModalBodyInfo} from "../testpage/QuestionModalInfo";
import {
  sanSub,
  sadSub,
  satSub,
  assrSub,
  matrixSub,
  paragraphSub,
  qstemSub,
  matchListSub,
} from "utilFunctions/Constants/Constants";
import { Title } from "Components/CommonComponents/GeneralComponents";
import QuestionTextProvider from "Components/CommonComponents/QuestionTextProvider";
import PropTypes from "prop-types";
import { getAPIRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";
import { BASE_URL_CMS } from "utilFunctions/Constants/urlConstants";

export function QuestionPreview({ question, questionType, regex }) {
  return (
    <div className="p-1">
      {/* <QuestionModalInfo question={question}/> */}
      <ModalBodyInfo
        question={question}
        questionType={questionType}
        regex={regex}
      />
    </div>
  );
}
QuestionPreview.propTypes = {
  question: PropTypes.object,
  questionType: PropTypes.any,
  regex: PropTypes.any,
};

export const getAppendImgUrl = (text) => {
  const myRegex = /<img[^>]+src="?([^"\s]+)"?\s*>/g;
  const url = myRegex.exec(text);
  // const s3BaseURL = imageUrl
  let newText = text;
  if (url && url.length > 0 && url[1].indexOf("s3") === -1) {
    const appendBaseURL = url[1];
    newText = text.replace(url[1], appendBaseURL);
  }
  return newText;
};
getAppendImgUrl.propTypes = {
  text: PropTypes.any,
};

export const ModalBodyInfo = ({
  question,
  questionType,
  regex,
  mode = "questionMain",
}) => {
  const sadRegexArray = [
    { label: "Date(dd-mm-yyyy)", value: "d{1,2}-d{1,2}-d{4}" },
    { label: "Time(hh:mm:ss)", value: "d{1,2}:d{1,2}:d{2}" },
  ];
  let dataset = [];
  let occur;
  let printtext = "";
  if (
    questionType === "MCMCQ" &&
    question !== undefined &&
    question.question !== undefined &&
    question.question.choices !== undefined &&
    Array.isArray(question.question.choices)
  ) {
    occur = question.question.choices.filter((c) => c.is_answer === true);
    occur.map((item) => {
      return dataset.push(item.choiceId);
    });
    printtext = dataset.join(",").split(" ");
  }
  if (
    (questionType === "SCMCQ" ||
      questionType === "ASSR" ||
      questionType === "MATCHLIST") &&
    question !== undefined &&
    question.question !== undefined &&
    question.question.choices !== undefined &&
    Array.isArray(question.question.choices)
  ) {
    occur = question.question.choices.filter((c) => c.is_answer === true);
    occur.map((item) => {
      return dataset.push(item.choiceId);
    });
    printtext = dataset.join(",").split(" ");
  }

  const getRegex = (ans, qtype) => {
    let reg = {
      value: "",
      label: "",
    };
    if (questionType == "SAN") {
      reg = sanSub.find((item) => item.value === ans);
    } else if (questionType == "SAT") {
      reg = satSub.find((item) => item.value === ans);
    } else if (questionType == "SAD") {
      reg = sadSub.find((item) => item.value === ans);
    } else if (questionType == "ASSR") {
      reg = assrSub.find((item) => item.value === ans);
    } else if (questionType == "MATCHLIST") {
      reg = matchListSub.find((item) => item.value === ans);
    } else if (questionType == "MATRIX") {
      reg = matrixSub.find((item) => item.value === ans);
    } else if (questionType == "Scenario") {
      reg = paragraphSub.find((item) => item.value === ans);
    } else if (questionType == "QSTEM" || qtype == "QSTEM") {
      reg = qstemSub.find((item) => item.value === ans);
    } else {
      reg = sadRegexArray.find((item) => item.value === ans);
    }
    var returnval =
      reg != undefined && reg != null && reg.label ? reg.label : "";
    return returnval;
  };
  const isChecked = (defaultData, _key) => {
    if (defaultData["answer"] && defaultData["answer"].indexOf(_key) > -1) {
      return true;
    } else {
      return false;
    }
  };
  const getIndex = (defaultData, type, index) => {
    const rowArray = ["A", "B", "C", "D", "E", "F", "G", "H"];
    const colArray = ["P", "Q", "R", "S", "T", "U", "V", "W"];
    let rowIndex =
      Array.isArray(defaultData["list1"]) && defaultData["list1"].length;
    let colIndex =
      Array.isArray(defaultData["list2"]) && defaultData["list2"].length;
    if (type == "row") {
      if (rowIndex <= index) {
        return rowArray[index];
      }
    } else {
      if (colIndex <= index) {
        return colArray[index];
      }
    }
  };
  const getArray = (num) => {
    return Array.from(Array(parseInt(num))).map((_, i) => i);
  };
  const getComprehension = (comprehension) => {
    if (comprehension) return comprehension;
    else return null;
  };

  const formMatrix = (ans, list2, list1) => {
    let matrixConfig = {
      answer: ans !== undefined && Array.isArray(ans) ? ans : [],
      row:
        list1 !== undefined && Array.isArray(list1)
          ? getArray(list1.length)
          : [],
      col:
        list2 !== undefined && Array.isArray(list2)
          ? getArray(list2.length)
          : [],
    };
    let defaultData = {
      answer: ans !== undefined && Array.isArray(ans) ? ans : [],
      list2: list2 !== undefined && Array.isArray(list2) ? list2 : [],
      list1: list1 !== undefined && Array.isArray(list1) ? list1 : [],
    };

    return (
      <Row className="mb-2">
        <Col md={12} className="my-4">
          <Row key={"row-0"} className="mb-0">
            <Col
              key={"row-0-col-0 text-center"}
              style={{ minWidth: "100px", maxWidth: "100px" }}
            ></Col>
            {matrixConfig["col"].map((index) => (
              <Col key={"row-0-col-" + index}>
                <Input
                  id="colInput2"
                  disabled={true}
                  isDisabled={true}
                  defaultValue={
                    defaultData["list2"][index]
                      ? defaultData["list2"][index]
                      : getIndex(defaultData, "col", index)
                  }
                  onChange={(e) => {
                    var n = defaultData;
                    n["list2"][index] = e.target.value;
                  }}
                  placeholder="---"
                  className="tdInput text-center mx-auto"
                  style={{ width: "80px", height: "40px" }}
                />
              </Col>
            ))}
          </Row>
          {matrixConfig["row"].map((index) => (
            <Row key={"row-" + (index + 1)}>
              <Col
                key={"row-" + (index + 1)}
                style={{
                  minWidth: "100px",
                  maxWidth: "100px",
                  marginBottom: "2px",
                }}
              >
                <Input
                  id="rowInput2"
                  disabled={true}
                  isDisabled={true}
                  defaultValue={
                    defaultData["list1"][index]
                      ? defaultData["list1"][index]
                      : getIndex(defaultData, "row", index)
                  }
                  onChange={(e) => {
                    var n = defaultData;
                    n["list1"][index] = e.target.value;
                  }}
                  placeholder="---"
                  className="tdInput text-center"
                />
              </Col>
              {matrixConfig["col"].map((jIndex) => (
                <Col
                  key={"col" + jIndex}
                  className="tdCell text-center mx-auto"
                >
                  <Input
                    disabled={true}
                    isDisabled={true}
                    defaultChecked={isChecked(
                      defaultData,
                      `${index + 1},${jIndex + 1}`
                    )}
                    id="checkbox"
                    onChange={(e) => {
                      var n = defaultData;
                      var _key = `${index + 1},${jIndex + 1}`;
                      if (e.target.checked) {
                        n["answer"] = [...n["answer"], _key];
                      } else {
                        n["answer"].splice(n["answer"].indexOf(_key), 1);
                      }
                    }}
                    type="checkbox"
                    className="mx-0 mt-3"
                  />
                </Col>
              ))}
            </Row>
          ))}
        </Col>
      </Row>
    );
  };
  const extraData = (question) => {
    return (
      <div>
        {question.question && question.question.explanation && (
          <div className="d-flex w-100 flex-column justify-content-start align-items-start">
            <div>
              <Title level={5}>Explanation</Title>
            </div>
            <div>
              <TextEditor
                content={getAppendImgUrl(question.question.explanation)}
              />
            </div>
          </div>
        )}
        {question.hints && question.hints !== undefined && (
          <div className="d-flex w-100 flex-column justify-content-start align-items-start">
            <div>
              <Title level={5}>Hint</Title>
            </div>
            <div>
              <TextEditor content={getAppendImgUrl(question.hints)} />
            </div>
          </div>
        )}
        {question.solution && question.solution !== undefined && (
          <div className="d-flex w-100 flex-column justify-content-start align-items-start">
            <div>
              <Title level={5}>Solution</Title>
            </div>
            <div>
              <TextEditor content={getAppendImgUrl(question.solution)} />
            </div>
          </div>
        )}
        {question.underlyingConcept &&
          question.underlyingConcept !== undefined && (
            <div className="d-flex w-100 flex-column justify-content-start align-items-start">
              <div>
                <Title level={5}>Underlying Concept</Title>
              </div>
              <div>
                <TextEditor
                  content={getAppendImgUrl(question.underlyingConcept)}
                />
              </div>
            </div>
          )}
        {question.newpossibleConcept &&
          question.newpossibleConcept !== undefined && (
            <div className="d-flex w-100 flex-column justify-content-start align-items-start">
              <div>
                <Title level={5}>New Possible Concept</Title>
              </div>
              <div>
                <TextEditor
                  content={getAppendImgUrl(question.newpossibleConcept)}
                />
              </div>
            </div>
          )}
        {question.ncertUnitId && question.ncertUnitId !== undefined && (
          <div className="d-flex w-100 flex-row ">
            <div>
              <Title level={5}>NCERT Unit :&nbsp;</Title>
            </div>
            <div className="ml-2">
              <p>{question.ncertUnitId}</p>
              {/* <TextEditor content={getAppendImgUrl(question.ncertUnitId)} /> */}
            </div>
          </div>
        )}
        {question.ncertChapterId && question.ncertChapterId !== undefined && (
          <div className="d-flex w-100 flex-row">
            <div>
              <Title level={5}>NCERT Chapter :&nbsp;</Title>
            </div>
            <div className="ml-2">
              <p>{question.ncertChapterId}</p>
              {/* <TextEditor content={getAppendImgUrl(question.ncertChapterId)} /> */}
            </div>
          </div>
        )}
        {question.ncertPageNumber && question.ncertPageNumber !== undefined && (
          <div className="d-flex w-100 flex-row">
            <div>
              <Title level={5}>NCERT Page Number :&nbsp;</Title>
            </div>
            <div className="ml-2">
              <p>{question.ncertPageNumber}</p>
              {/* <TextEditor content={getAppendImgUrl(question.ncertPageNumber)} /> */}
            </div>
          </div>
        )}
        {question.bookId && question.bookId !== undefined && (
          <div className="d-flex w-100 flex-row">
            <div>
              <Title level={5}>BOOK :&nbsp;</Title>
            </div>
            <div className="ml-2">
              <p>{question.bookId}</p>
              {/* <TextEditor content={getAppendImgUrl(question.bookId)} /> */}
            </div>
          </div>
        )}
        {question.ncertExerciseNumber &&
          question.ncertExerciseNumber !== undefined && (
            <div className="d-flex w-100 flex-row">
              <div>
                <Title level={5}>NCERT Exercise Number :&nbsp;</Title>
              </div>
              <div className="ml-2">
                <p>{question.ncertExerciseNumber}</p>
                {/* <TextEditor content={getAppendImgUrl(question.ncertExerciseNumber)} /> */}
              </div>
            </div>
          )}
      </div>
    );
  };
  switch (questionType) {
    case "SCMCQ":
    case "ASSR":
    case "MCMCQ":
    case "MATCHLIST":
      if (
        question &&
        question.question !== undefined &&
        Array.isArray(question.question.choices)
      ) {
        question.question.choices = question.question.choices.sort(function (
          a,
          b
        ) {
          return a.choiceId > b.choiceId ? 1 : b.choiceId > a.choiceId ? -1 : 0;
        });
      }
      return (
        <>
          <div className="d-flex flex-column mb-2 justify-content-start align-items-start">
            <Title level={5}>Question</Title>
            {question && question.question !== undefined && (
              <TextEditor content={getAppendImgUrl(question.question.text)} />
            )}
          </div>

          {question &&
          question.question !== undefined &&
          Array.isArray(question.question.choices) ? (
            <>
              <table className="table option_table table-bordered">
                {question.question.choices.map((o, i) => {
                  return (
                    <tr key={i}>
                      <td className="align-middle text-center" width="50px">
                        {o.choiceId}
                      </td>
                      <td className="align-middle align-items-center">
                        <TextEditor
                          content={getAppendImgUrl(o.text)}
                          isAnswer={o.is_answer}
                        />
                        {/* {o.is_answer && <span>Correct Answer</span>} */}
                      </td>
                    </tr>
                  );
                })}
              </table>
            </>
          ) : null}

          {question &&
            question.question !== undefined &&
            ["ASSR", "MATCHLIST"].includes(questionType) && (
              <div className="d-flex flex-row mt-3 align-content-center">
                <Title level={5}>Subtype</Title>
                {question.question.regex !== undefined &&
                  question.question.regex !== null && (
                    <p className="px-3 font-weight-normal">
                      {" "}
                      {getRegex(question.question.regex, questionType)}{" "}
                    </p>
                  )}
              </div>
            )}
          <div className="d-flex flex-row mt-3 align-content-center">
            <Title level={5}>Correct Option :&nbsp;</Title>

            <p className="px-3 font-weight-bold">{printtext}</p>
          </div>
          {mode != "AIHint" ? extraData(question) : null}
        </>
      );

    case "SAN":
    case "SAT":
    case "SAD":
      return (
        <>
          <div className="d-flex flex-column mb-2 justify-content-start align-items-start">
            <Title level={5}>Question</Title>
            {question &&
              question.question !== undefined &&
              question.question !== null && (
                <TextEditor content={getAppendImgUrl(question.question.text)} />
              )}
          </div>
          {question && question.question !== undefined && (
            <div className="d-flex flex-row mt-3 align-content-center">
              <Title level={5}>Subtype</Title>
              {question.question.regex !== undefined &&
                question.question.regex !== null && (
                  <p className="px-3 font-weight-normal">
                    {" "}
                    {getRegex(question.question.regex, questionType)}{" "}
                  </p>
                )}
            </div>
          )}
          {question && question.question !== undefined && (
            <div className="d-flex flex-row mt-2 align-content-center">
              <Title level={5}>Correct Answer</Title>
              {question.question.answer !== undefined &&
                question.question.answer !== null && (
                  <p className="px-3 font-weight-normal">
                    {" "}
                    {question.question.answer}{" "}
                  </p>
                )}
            </div>
          )}
          {mode != "AIHint" ? extraData(question) : null}
        </>
      );

    case "TF":
      return (
        <>
          <div className="d-flex flex-column mb-2 justify-content-start align-items-start">
            <Title level={5}>Question</Title>
            {question && question.question !== undefined && (
              <TextEditor content={getAppendImgUrl(question.question.text)} />
            )}
            {question && question.question !== undefined && (
              <div className="d-flex flex-row mt-2 align-content-center">
                <Title level={5}>Correct Answer</Title>
                {question.question.answer !== undefined && (
                  <p className="px-3 font-weight-normal">
                    {" "}
                    {question.question.answer ? "true" : "false"}{" "}
                  </p>
                )}
              </div>
            )}
          </div>
          {mode != "AIHint" ? extraData(question) : null}
        </>
      );

    case "MATRIX":
      return (
        <>
          <div className="d-flex flex-column mb-2 justify-content-start align-items-start">
            <Title level={5}>Question</Title>
            {question && question.question !== undefined && (
              <TextEditor content={getAppendImgUrl(question.question.text)} />
            )}

            {question &&
              question.question !== undefined &&
              question.question.answer !== undefined &&
              question.question.list2 !== undefined &&
              question.question.list1 !== undefined &&
              formMatrix(
                question.question.answer,
                question.question.list2,
                question.question.list1
              )}
            {question && question.question !== undefined && (
              <div className="d-flex flex-row mt-3 align-content-center">
                <Title level={5}>Subtype</Title>
                {question.question.regex !== undefined &&
                  question.question.regex !== null && (
                    <p className="px-3 font-weight-normal">
                      {" "}
                      {getRegex(question.question.regex, questionType)}{" "}
                    </p>
                  )}
              </div>
            )}
          </div>
          {mode != "AIHint" ? extraData(question) : null}
        </>
      );
    case "QSTEM":
    case "Scenario":
      return (
        <>
          <div className="d-flex flex-column mb-2 justify-content-start align-items-start">
            <Title level={5}>Question</Title>
            {question && question?.question && question.question !== null && (
              <TextEditorQSTEM
                text={getComprehension(question.question.text)}
              />
            )}
            {question && question.question !== undefined && (
              <div className="d-flex flex-row mt-3 align-content-center">
                <h5 style={{ fontSize: "14px", marginTop: "3px" }}>
                  Subtype :
                </h5>
                {regex !== undefined && regex !== null && (
                  <p className="px-3 font-weight-normal">
                    {" "}
                    {getRegex(question.question.regex, questionType)}{" "}
                  </p>
                )}
              </div>
            )}
          </div>
        </>
      );
  }
};
ModalBodyInfo.propTypes = {
  question: PropTypes.any,
  questionType: PropTypes.any,
  regex: PropTypes.any,
  mode: PropTypes.any,
};
const TextEditor = ({ content }) => {
  return (
    <div
      className="mb-1 w-80"
      id="compersive"
      style={{ whiteSpace: "normal", textAlign: "left", color: "black" }}
    >
      <QuestionTextProvider content={content} />
    </div>
  );
};
TextEditor.propTypes = {
  content: PropTypes.any,
};

const TextEditorQSTEM = ({ text }) => {
  const [content, setContent] = useState(text);

  const findAsset = (data, cb = null, cb1 = null) => {
    let wrapper = document.createElement("div");
    wrapper.innerHTML = data;
    let images = wrapper.querySelectorAll("img");
    if (images && images.length > 0) {
      images.forEach(async (img) => {
        if (
          img.src.substring(0, 4) != "http" ||
          img.src.indexOf(window.location.host) > -1
        ) {
          if (
            img.src.split(window.location.host + "/")[1] == "" ||
            img.src.split(window.location.host + "/")[1] == undefined
          ) {
            cb(wrapper.innerHTML);
          } else {
            let imgSrc = img.src.split(window.location.host + "/")[1];
            getAPIRequest(
              BASE_URL_CMS + "assets?assetType=Image&imageName=" + imgSrc,
              (response) => {
                if (
                  response &&
                  response["response"] &&
                  response["response"][0]
                ) {
                  wrapper
                    .querySelectorAll(`[src='${imgSrc}']`)
                    .forEach((_i) => {
                      _i.setAttribute("src", response["response"][0]["url"]);
                    });
                  if (cb) {
                    cb(wrapper.innerHTML);
                  }
                  if (cb1) {
                    cb1(wrapper.innerHTML);
                  }
                } else {
                  cb(wrapper.innerHTML);
                }
              },
              () => {
                if (cb) {
                  cb(wrapper.innerHTML);
                }
              }
            );
          }
        } else {
          if (cb) {
            cb(wrapper.innerHTML);
          }
        }
      });
    } else {
      if (cb) {
        cb(wrapper.innerHTML);
      }
    }
  };
  useEffect(() => {
    findAsset(content, (data) => {
      setContent(data);
    });
  }, []);

  return (
    <>
      <div
        id="compersive"
        className="mb-1 w-80"
        style={{ whiteSpace: "normal" }}
      >
        <QuestionTextProvider content={content} />
      </div>
    </>
  );
};

TextEditorQSTEM.propTypes = {
  text: PropTypes.any,
};
